import React from 'react'
import Head from 'next/head'
import Layout from 'components/shared/Layout'
import LabelTitleText from 'components/shared/LabelTitleText'
import GroupedPlanDetailsCard from 'src/components/shared/PlanDetailsCard/GroupedPlanDetailsCard'
import classnames from 'classnames/bind'
import css from './styles.module.scss'
import useGroupedCards from './useGroupedCards'

const cx = classnames.bind(css)

const PlanCards = ({ className, intro, cards }) => {
  const smallLayout = cards.length <= 2
  const Wrapper = smallLayout ? Layout : 'div'

  const groupedCards = useGroupedCards(cards)

  return (
    <>
      <div className={cx(className)}>
        <Layout type="wrapper" className={css.wrapper}>
          <Wrapper
            {...(smallLayout && {
              type: 'mediumInnerWrapper',
            })}
          >
            {intro && (
              <LabelTitleText className={css.intro} {...intro} center />
            )}
            <div className={css.grid}>
              {groupedCards &&
                groupedCards.map((cardGroup, index) => (
                  <GroupedPlanDetailsCard
                    key={index}
                    cards={cardGroup}
                    previousPlanName={
                      groupedCards[index - 1]?.[0]?.plan?.data?.attributes?.name
                    }
                  />
                ))}
            </div>
          </Wrapper>
        </Layout>
      </div>
    </>
  )
}

PlanCards.defaultProps = {}

export default PlanCards
